/* Pivot (oct. 2026) : inviter les gens a se connecter / enregistrer leur van
   Accueil seulement : une ligne avec lien sous le bloc "Products Designed for Your Vehicle"
   (si pas de van enregistre). Le message sur les pages produits a ete retire. */
(function () {
  var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var logged = window.PivotCustomerLoggedIn === true;
  var van = (window.PivotVan || '').toString().toLowerCase().trim();
  var loginUrl = '/account/login';
  var profileUrl = 'https://myaccount.pivotequipment.com/profile';

  if (!document.getElementById('pv-acct-style')) {
    var css = '' +
      '.pv-home-cta{text-align:center;margin:20px auto 0;font-size:14px;line-height:1.5;color:rgba(31,26,16,.7)}' +
      '.pv-home-cta a{color:#1f1a10;text-decoration:underline;text-underline-offset:3px;font-weight:500}';
    var style = document.createElement('style');
    style.id = 'pv-acct-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function homeCta() {
    if (document.querySelector('.pv-vehicle-picks')) return;
    var section = document.querySelector('.collection-list[class*="collection_list_MEUpxX"]');
    if (!section) return;
    var wrapper = section.querySelector('.section__wrapper') || section;
    if (wrapper.querySelector('.pv-home-cta')) return;
    var html;
    if (!logged) {
      html = fr
        ? '<a href="' + loginUrl + '">Connectez-vous et enregistrez votre van</a> pour voir directement les bons produits.'
        : '<a href="' + loginUrl + '">Sign in and save your van</a> to see the right products for it.';
    } else if (!van) {
      html = fr
        ? '<a href="' + profileUrl + '">Enregistrez votre van</a> pour voir directement les bons produits.'
        : '<a href="' + profileUrl + '">Save your van</a> to see the right products for it.';
    } else {
      return;
    }
    var cta = document.createElement('p');
    cta.className = 'pv-home-cta';
    cta.innerHTML = html;
    wrapper.appendChild(cta);
    /* Moins d'espace sous la ligne avant le bloc suivant */
    section.style.setProperty('--section-padding-bottom', '16px');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', homeCta);
  else homeCta();
  window.addEventListener('load', homeCta);
})();
